module.exports = __webpack_public_path__ + "static/media/02.075a01d0.jpg";